import { render, staticRenderFns } from "./edit-template-modal.vue?vue&type=template&id=17dffedb"
import script from "./edit-template-modal.vue?vue&type=script&lang=js"
export * from "./edit-template-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports